'use client'

import type { SocialLinkItemProps } from '@maestro/commerce-blocks/components/socials-list/social-list.types'

import classNames from 'classnames'
import React, { useCallback } from 'react'

import { useEventBusContext } from '@maestro/core/event/event-bus.context'
import { EventType } from '@maestro/data-layer'
import { Link } from '@pearlconvert/ui/components/link'

export default function SocialLinkItem({
  link,
  title,
  type,
}: SocialLinkItemProps) {
  const { publish } = useEventBusContext()

  const handleClickSocial = useCallback(() => {
    publish(EventType.FOOTER_LINK_CLICKED, {
      level1: 'Social Media',
      level2: title,
      click_url: link,
      click_text: title,
    })
  }, [link, publish, title])

  return (
    <Link
      className={classNames('socials__link', {
        [`i-${type}`]: type,
      })}
      href={link}
      target={'_blank'}
      onClick={handleClickSocial}
    >
      <span>{title}</span>
    </Link>
  )
}
